import React, { useEffect, useState } from "react";

const INSTALL_DONE_KEY = "ferrea_pwa_installed";

function isStandaloneMode() {
  const isDisplayStandalone =
    window.matchMedia &&
    window.matchMedia("(display-mode: standalone)").matches;
  const isIosStandalone = window.navigator.standalone === true;
  return isDisplayStandalone || isIosStandalone;
}

function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent || "");
}

function InstallPWAButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (isStandaloneMode()) return;
    if (window.localStorage.getItem(INSTALL_DONE_KEY) === "1") return;

    setShowBanner(true);

    const beforeInstallHandler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    const installedHandler = () => {
      window.localStorage.setItem(INSTALL_DONE_KEY, "1");
      setShowBanner(false);
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", beforeInstallHandler);
    window.addEventListener("appinstalled", installedHandler);

    return () => {
      window.removeEventListener("beforeinstallprompt", beforeInstallHandler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  const dismissBanner = () => {
    setShowBanner(false);
  };

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    deferredPrompt.prompt();
    try {
      await deferredPrompt.userChoice;
    } finally {
      setShowBanner(false);
      setDeferredPrompt(null);
    }
  };

  if (!showBanner) return null;

  const hintText = isIos()
    ? "iPhone: Share > Add to Home Screen"
    : "Browser menu: Install app";

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        background: "#111",
        color: "#fff",
        zIndex: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
        padding: "6px 12px",
        fontSize: 13,
        fontWeight: 500,
        boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
        flexWrap: "nowrap",
      }}
    >
      <span
        style={{
          fontWeight: 700,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        Install Ferrea App
      </span>

      {deferredPrompt ? (
        <button
          onClick={handleInstallClick}
          style={{
            background: "#ff3b82",
            color: "#fff",
            border: "none",
            borderRadius: 999,
            padding: "4px 12px",
            fontWeight: 700,
            fontSize: 12,
            cursor: "pointer",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            whiteSpace: "nowrap",
          }}
        >
          Install App
        </button>
      ) : (
        <span
          style={{
            opacity: 0.9,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {hintText}
        </span>
      )}

      <button
        onClick={dismissBanner}
        style={{
          background: "transparent",
          color: "#fff",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
          lineHeight: 1,
          padding: 0,
        }}
        aria-label="Close install app banner"
      >
        x
      </button>
    </div>
  );
}

export default InstallPWAButton;
